import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/game-builder', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createGame(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('/game-builder', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    loadGame(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/game-builder/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    suggestAutotopic(ctx, { gameId, rtId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/game-builder/${gameId}/round-topic/${rtId}/suggest-autotopic`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    acceptAutotopic(ctx, { gameId, rtId, autotopicId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/game-builder/${gameId}/round-topic/${rtId}/accept-autotopic`, { autotopic_id: autotopicId })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    suggestMovie(ctx, { gameId, rtId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/game-builder/${gameId}/round-topic/${rtId}/suggest-movie`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    acceptQuestion(ctx, { gameId, rtId, payload }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/game-builder/${gameId}/round-topic/${rtId}/accept-question`, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteQuestion(ctx, { gameId, rtId, questionId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/game-builder/${gameId}/round-topic/${rtId}/question/${questionId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeTopic(ctx, { gameId, rtId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/game-builder/${gameId}/round-topic/${rtId}/remove-topic`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteGame(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/game-builder/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchAutotopics(ctx, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .get('/autotopic', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    exportSiq(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/game-builder/${id}/export-siq`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadSiq(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/game-builder/${id}/download-siq`, { responseType: 'blob' })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    finalizeGame(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/game-builder/${id}/finalize`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
